/* -------------------------------------------------------------------------- */
/*                            Version: %%GULP_INJECT_VERSION%%                                  */
/* -------------------------------------------------------------------------- */

import { docReady, getCookie } from './utils';
// import setTenantData from './vv_setTenantData';
// docReady(setTenantData);
//import handleNavbarVerticalCollapsed from './navbar-vertical';
import detectorInit from './detector';
import tooltipInit from './tooltip';
import popoverInit from './popover';
//import navbarTopDropShadow from './navbar-top';
import toastInit from './toast';
//import formValidationInit from './form-validation';
//import navbarDarkenOnScroll from './navbar-darken-on-scroll';
//import navbarComboInit from './navbar-combo';
//import searchInit from './search';
import themeControl from './theme-control';
import dropdownOnHover from './dropdown-on-hover';
import scrollbarInit from './scrollbar';
import iconCopiedInit from './icons';
import dropdownMenuInit from './dropdown-menu';
//import treeviewInit from './treeview';

/* -------------------------------------------------------------------------- */
/*                            VV Theme Imports                                */
/* -------------------------------------------------------------------------- */
import vv_utils from './vv_utils';
import passwordShowHideInit from './vv_passwordShowHide';
import changeLogoDimensions from './vv_changeLogoDimensions';
import registerValidationInit from './vv_registerValidation';
import resetValidationInit from './vv_resetValidation';
import forgotPasswordInit from './vv_forgotpassword';
import loginValidationInit from './vv_loginValidation';
import { verifyInit, verifyInit_onStart } from './vv_verify';
import {errorDetailsInit_onStart} from "./vv_errorDetails";
import {consentDetailsInit_onStart} from "./vv_consentDetails";
import {supportInit_onStart} from "./vv_support";
import {settingsInit_onStart} from "./vv_settings";
import {mfaEnrollInit_onStart} from "./vv_mfaEnroll";
import {mfaVerifyInit_onStart} from "./vv_mfaVerify";
import {settingsdebugInit_onStart} from "./vv_settingsdebug";

import vv_c from "./vv_c";

const CONFIG = {
  isNavbarVerticalCollapsed: false,
  theme: 'light',
  // isRTL: false,
  // isFluid: false,
  // navbarStyle: 'transparent',
  // navbarPosition: 'vertical'
};

Object.keys(CONFIG).forEach(key => {
  if (localStorage.getItem(key) === null) {
    localStorage.setItem(key, CONFIG[key]);
  }
});

if (!!JSON.parse(localStorage.getItem('isNavbarVerticalCollapsed'))) {
  document.documentElement.classList.add('navbar-vertical-collapsed');
}

if (localStorage.getItem('theme') === 'dark') {
  document.documentElement.classList.add('dark');
}


/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(detectorInit);
//docReady(handleNavbarVerticalCollapsed);
//docReady(navbarTopDropShadow);
docReady(tooltipInit);
docReady(popoverInit);
docReady(toastInit);
//docReady(formValidationInit);
//docReady(navbarDarkenOnScroll);
//docReady(navbarComboInit);
//docReady(searchInit);
docReady(themeControl);
docReady(dropdownOnHover);
docReady(scrollbarInit);
docReady(iconCopiedInit);
docReady(dropdownMenuInit);
//docReady(treeviewInit);
/* -------------------------------------------------------------------------- */
/*                           VV Theme Initialization                          */
/* -------------------------------------------------------------------------- */
docReady(passwordShowHideInit);
docReady(changeLogoDimensions);

docReady( () => {
  
  const urlparams = new URLSearchParams(window.location.search);
  const action = urlparams.get("vv_action");
  const getStartedGoalId = "1";
  if (action && action === "register") {
    vv_utils.addTracking(getStartedGoalId, "");
  } else {
    vv_utils.addTracking("", "");
  }
});


docReady( () => {
  window.addEventListener("error", function (e) {
    if (JSON.stringify(e) !== '{"isTrusted":true}') {
      
      
      vv_utils.logError(e.error);
    }
    return false;
  });

  window.onStartHandler = {
    "verifyInit_onStart" : verifyInit_onStart,
    "supportInit_onStart" : supportInit_onStart,
    "errorDetailsInit_onStart": errorDetailsInit_onStart,
    "consentDetailsInit_onStart": consentDetailsInit_onStart,
    "registerValidationInit":registerValidationInit,
    "resetValidationInit": resetValidationInit,
    "forgotPasswordInit": forgotPasswordInit,
    "loginValidationInit": loginValidationInit,
    "mfaEnrollInit_onStart": mfaEnrollInit_onStart,
    "mfaVerifyInit_onStart": mfaVerifyInit_onStart,
    "settingsInit_onStart": settingsInit_onStart,
    "settingsdebugInit_onStart": settingsdebugInit_onStart
  }
});

docReady( () => {
  let onstart = document.getElementById('onstart');

  if (onstart && onstart.dataset && onstart.dataset.onstart) {
    window.onStartHandler[onstart.dataset.onstart]();
  }
});
